<template>
  <div>
      <div>
        <el-select v-model="queryBycompanyId" placeholder="请选择" @change="handleChangecompanyId" clearable>
          <el-option
            v-for="item in companyList"
            :key="item.key"
            :label="item.chineseName?item.chineseName:item.englishName"
            :value="item.id">
            <span style="float: left">{{ item.chineseName }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.englishName }}</span>
          </el-option>
        </el-select>
        <el-select v-model="contactstatus" placeholder="请选择" @change="handleChangeContactStatus">
          <el-option
            v-for="n in companyStatus"
            :key="n.key"
            :label="n.label"
            :value="n.value">
          </el-option>
        </el-select>
    </div>
    <div class="comond_btn">
      <el-button  @click="handleEdit(0, null)" >添加联系人</el-button>
    </div>
    <template>
      <el-table
        :data="list"
        style="width: 100%">
        <el-table-column
          prop="company"
          label="公司名称"
          width="">
        </el-table-column>
        <el-table-column
          label="名字">
          <template slot-scope="scope">
             <div>{{ (scope.row.name) }}</div>
           </template>
        </el-table-column>
        <el-table-column
          prop="phone"
          label="联系方式">
        </el-table-column>
        <el-table-column
          prop="position"
          label="职位">
        </el-table-column>
        <el-table-column
          prop="email"
          label="邮箱">
        </el-table-column>
        <el-table-column
          prop="weChat"
          label="微信">
        </el-table-column>
        <el-table-column
          label="是否为主要联系人">
           <template slot-scope="scope">
             <div>{{ scope.row.isMajor === 'Y'? '是': '否' }}</div>
           </template>
        </el-table-column>
        <!-- <el-table-column
          prop="updateBy"
          label="创建人">
        </el-table-column>
         <el-table-column
          label="创建时间">
          <template slot-scope="scope">
             <div>{{ formatime(scope.row.updateTime) }}</div>
           </template>
        </el-table-column>
         <el-table-column
          prop="updateBy"
          label="更新人">
        </el-table-column>
         <el-table-column
          label="更新时间">
          <template slot-scope="scope">
             <div>{{ formatime(scope.row.updateTime) }}</div>
           </template>
        </el-table-column> -->
        <el-table-column
          width="160"
          label="操作选项">
           <template slot-scope="scope">
            <el-button
              size="mini"
              @click="handleEdit(1, scope.row)">编辑</el-button>
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <div>
      <el-dialog
        :title="title"
        :visible.sync="centerDialogVisible"
        width="28%"
        center>
        <el-form :model="form" :rules="rules">
          <el-form-item label="关联公司" :label-width="formLabelWidth" prop="companyId">
            <el-select v-model="form.companyId" placeholder="请选择" >
              <el-option
                v-for="item in companyList"
                :key="item.key"
                :label="item.chineseName?item.chineseName:item.englishName"
                :value="item.id">
                <span style="float: left">{{ item.chineseName }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.englishName }}</span>
              </el-option>
            </el-select>
          </el-form-item>
           <el-form-item label="联系人" :label-width="formLabelWidth" prop="name">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
           <el-form-item label="联系方式" :label-width="formLabelWidth" prop="phone">
            <el-input v-model="form.phone"></el-input>
          </el-form-item>
          <el-form-item label="职位" :label-width="formLabelWidth" prop="positionId">
            <el-select v-model="form.positionId" placeholder="请选择" >
              <el-option
                v-for="item in positionList"
                :key="item.key"
                :label="item.position"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
           <el-form-item label="邮箱" :label-width="formLabelWidth">
            <el-input v-model="form.email"></el-input>
          </el-form-item>
           <el-form-item label="微信" :label-width="formLabelWidth">
            <el-input v-model="form.weChat"></el-input>
          </el-form-item>
           <el-form-item label="主要联系人" :label-width="formLabelWidth">
            <el-select v-model="form.isMajor" placeholder="请选择">
              <el-option
                v-for="item in isMajorList"
                :key="item.key"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="centerDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handlesuccess(sts)">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { queryByCompanyId, contactfindAll, contactadd, contactupdate, contactdelete, findAll, positionfindAll } from '../../api'
import utils from '../../../public/utils'
import qs from 'qs'
export default {
  data () {
    return {
      list: [],
      companyList: [], //  公司列表
      companyStatus: [ //  公司状态列表
        {
          value: null,
          label: '所有'
        },
        {
          value: 1,
          label: '有效联系人'
        },
        {
          value: 2,
          label: '无效联系人'
        }
      ],
      isMajorList: [
        {
          label: '是',
          value: 'Y'
        },
        {
          label: '否',
          value: 'N'
        }
      ],
      queryBycompanyId: '', //  根据公司ID查询
      contactstatus: 1, //  默认有效联系人
      positionList: [], //  职位列表
      centerDialogVisible: false,
      form: { //  新增初始化form
        companyId: '', //  公司ID
        name: '', //  联系人姓名
        phone: '', //  联系方式
        positionId: '', //  职位
        email: '', //  邮箱
        weChat: '', //  微信
        isMajor: '', //  是否主要联系人
      },
      formLabelWidth: '120px',
      sts: 0, //  0 添加, 1 编辑
      title: '', //  添加窗口标题
      rules: {
        positionId: [
          { required: true, message: '请选择公司职业', trigger: 'change' },
        ],
        companyId: [
          { required: true, message: '请选择联系公司', trigger: 'change' },
        ],
        name: [
          { type: 'string', required: true, message: '请输入联系人', trigger: 'blur' },
        ],
        phone: [
          { type: 'string', required: true, message: '请输入联系方式', trigger: 'blur' },
        ]
      }
    }
  },
  methods: {
    handleEdit (ind, row) { //  编辑或者新增
      this.centerDialogVisible = true
      console.log(ind, row)
      this.getpositionfindAll()
      if (ind === 1) {
        this.title = '编辑联系人'
        this.form = row
        this.sts = 1
      } else {
        this.title = '新增联系人'
        this.form = {}
        this.sts = 0
      }
    },
    handlesuccess (sts) { //  提交修改信息
      if (sts === 0) {
        let para = new URLSearchParams(this.form)
        contactadd(para).then(data => {
          if (data.code === 10000) {
            this.$message({
              message: data.msg,
              type: 'success'
            })
            this.getcontactfindAll(this.queryBycompanyId, this.contactstatus)
            this.centerDialogVisible = false
          } else {
            this.$message({
              message: data.msg,
              type: 'error'
            })
          }
        })
      } else {
        //  修改角色信息
        let para = new URLSearchParams(this.form)
        contactupdate(para).then(data => {
          if (data.code === 10000) {
            this.$message({
              message: data.msg,
              type: 'success'
            })
            this.getcontactfindAll(this.queryBycompanyId, this.contactstatus)
            this.centerDialogVisible = false
          } else {
            this.$message({
              message: data.msg,
              type: 'error'
            })
          }
        })
      }
    },
    handleChangecompanyId (val) { //  根据公司ID查询联系人
      // this.queryBycompanyId = val
      this.getcontactfindAll(this.queryBycompanyId, this.contactstatus)
    },
    handleChangeContactStatus (val) { //  根据联系人状态查询联系人
      // this.contactstatus = val
      this.getcontactfindAll(this.queryBycompanyId, this.contactstatus)
    },
    handleDelete (ind, row) { //  删除
      console.log(ind, row)
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then( () => {
        let para = new URLSearchParams()
        para.append('id', row.id)
        contactdelete(para).then( data => {
          if (data.code === 10000) {
            this.$message({
              message: data.msg,
              type: 'success'
            })
            this.getcontactfindAll(this.queryBycompanyId, this.contactstatus)
          } else {
            this.$message({
              message: data.msg,
              type: 'error'
            })
          }
        })
      })
    },
    getcontactfindAll (c, s) { //  查询联系人
      let params = {
        companyId: c,
        status: s,
      }
      contactfindAll(params).then(data => {
        console.log(data)
        this.list = data.data.data
      })
    },
    getfindAll (s, t) { //  查询全部公司
      let para = {
        status: s,
        typeId: t
      }
      findAll(para).then(data => {
        console.log(data)
        this.companyList = data.data.data
      })
    },
    getpositionfindAll(s, t) { //  查询全部职位
      let para = {
      }
      positionfindAll(para).then(data => {
        console.log(data)
        this.positionList = data.data.data
      })
    },
    formatime (s) { //  格式化时间
      let a = utils.formatterTime(s)
      return a
    },
  },
  mounted () {
    this.getfindAll(1, null)
    this.getcontactfindAll(this.queryBycompanyId, this.contactstatus)
  }
}
</script>
<style lang="stylus" scoped>
.comond_btn
  display flex
  justify-content flex-end
  margin-bottom 30px
  button
    background-color #0a3d5f
    color #fff
</style>
